import * as React from 'react';
import Lozenge from '@atlaskit/lozenge';
import { ProductStatus } from '../../../types/types';

interface Props {
  status: string;
  className?: string;
  testId?: string;
}

export const ProductStatusLozenge = ({ status, className = '', testId = '' }: Props) => {
  let statusColour: 'default' | 'new' | 'moved' | 'inprogress' | 'removed';
  switch (status) {
    case ProductStatus.NEW:
      statusColour = 'new';
      break;
    case ProductStatus.TRANSFER:
      statusColour = 'moved';
      break;
    case ProductStatus.EDITED:
      statusColour = 'inprogress';
      break;
    case ProductStatus.CANCEL:
      statusColour = 'removed';
      break;
    default:
      statusColour = 'default';
  }
  return (
    <div className={className} data-testId={testId}>
      <Lozenge testId={'product-status-lozenge'} appearance={statusColour}>
        {status}
      </Lozenge>
    </div>
  );
};
